import { useEffect, useRef } from 'react';
import { useBackButton } from '../hooks/useBackButton';
import { getTelegramStartParam } from '../utils/referral';
import { IconBack } from './icons';
import { NotificationSettings } from './NotificationSettings';
import { ReferralCard } from './ReferralCard';
import { StarsCheckoutCard } from './StarsCheckoutCard';
import './SettingsScreen.css';

interface SettingsScreenProps {
  onBack: () => void;
}

export function SettingsScreen({ onBack }: SettingsScreenProps) {
  useBackButton(onBack);
  const starsSectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (getTelegramStartParam() !== 'support_stars') return;
    const id = window.setTimeout(() => {
      starsSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div className="settings-screen">
      <div className="settings-header">
        <button type="button" className="settings-header-back" onClick={onBack} aria-label="Назад">
          <IconBack size={20} />
        </button>
        <span className="settings-header-title">Настройки</span>
      </div>

      <div className="section-label settings-section-label">Уведомления</div>
      <NotificationSettings hideHeader />

      <div className="section-label settings-section-label" style={{ marginTop: 18 }}>Реферальная программа</div>
      <div className="settings-referral-wrap">
        <ReferralCard variant="full" />
      </div>

      <div className="section-label settings-section-label" style={{ marginTop: 18 }}>
        Поддержка проекта
      </div>
      <div className="settings-stars-wrap" ref={starsSectionRef}>
        <StarsCheckoutCard />
      </div>
    </div>
  );
}
